// extracted by mini-css-extract-plugin
module.exports = {"efaxOrdersLabel":"InboxSidebar_efaxOrdersLabel__2cfyB","unassignedEfaxes":"InboxSidebar_unassignedEfaxes__3PaYQ"};